export default "__VITE_ASSET__DEIAB1l0__"